/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import UploadTransactionsColumns from './UploadTransactionsColumns';
import UploadTransactionsRows from './UploadTransactionsRows';

type TransactionsTableProps = {
  sort: string,
  order: string,
  children: any,
  router: Object,
  projectInReview: boolean,
  customDataTestID?: string,
}

export default function UploadTransactionsTable({
  children, sort, order, router, projectInReview, customDataTestID,
}: TransactionsTableProps): React.Element {
  return (
    <Table>
      <UploadTransactionsColumns sort={sort} order={order}/>
      <UploadTransactionsRows router={router} projectInReview={projectInReview}>
        {children}
      </UploadTransactionsRows>
    </Table>
  );
}
